module.exports = __webpack_public_path__ + "08be48ae413a4821f4f462136c38837e.png";


/*****************
 ** WEBPACK FOOTER
 ** ./src/images/phyto/1day.png
 ** module id = 477
 ** module chunks = 0
 **/